import Vue from 'vue';
import { Component } from 'vue-property-decorator';

declare var _hmt: any;

@Component({
    components: {
        DirectionalComponent: () => import('./directionalcheck.vue'),
    }
})
export default class CheckTaskComponent extends Vue {
    progress: String = '上传作业';//进程
    progressIndex: number = 0;
    checkTaskName: string = '';//学习任务名称
    listLoading: Boolean = false;
    fileList: any = [];//文件列表
    fileListIsShow: Boolean = true;
    fileObjList: Array<any> = [];//文件对象列表
    //isCanhandle = true;
    //isSelfCheckExplain: Boolean = false;//作业互查说明是否显示
    //isDirectionalExplain: Boolean = false;//定向检测说明是否显示
    isHaveCheckdb: Boolean = false;//是否存在自建库
    checkdbName: String = '';//自建库名称
    isEachOther: number = 0;//是否互查
    isCheckDb: number = 0;//是否对比库检测
    startCheckIsShow: Boolean = false;//是否显示开始检测提示
    checkTypeText: String = '';//选择检测类型
    studyTaskNum: number = 0;//当前学习任务个数
    isStudyTask: Boolean = true;//是否有能添加学习任务
    checkTaskId: String = 'undefined';//任务id未定义
    receiveData: any = {
        type: '',
        fileList: []
    };//接收数据
    fileNameList: any = []//文件名列表
    isCheckName: Boolean = false;//任务名称
    isEditable: Boolean = true;//按钮是否可编辑
    delList: any = []//删除文件列表
    currentPage: number = 1;
    pageSize: number = 10;
    fullscreenLoading: Boolean = true;
    isAllSelect: Boolean = false;//是否全选
    FileListLen: number = 0;
    successLen: number = 0;
    loadingText: string = '请稍等';
    checkDBListIsShow: Boolean = false;//万方库是否显示
    checkDBList: any = [];//所有的万方库
    checkList: any = [];//选择的学术库
    restCount: number = 0;//剩余检测余额
    fileNum: number = 0;//上传文件数量

    urlObj = {
        selfCheck: {
            name: '作业互查',
            state: 'normal',
            normal: require('@/images/selfCheck.png'),
            selected: require('@/images/selfCheck-selected.png'),
        },
        chechDb: {
            name: '学术库检测',
            state: 'normal',
            normal: require('@/images/chechDb.png'),
            selected: require('@/images/chechDb-selected.png'),
        },
        directional: {
            name: '定向检测',
            state: 'normal',
            normal: require('@/images/directional.png'),
            selected: require('@/images/directional-selected.png'),
        }
    }

    progressObj = {
        '0': {
            progress: '上传作业',
            progressIndex: 0,
        },
        '1': {
            progress: '检测设置',
            progressIndex: 1,
        },
        '2': {
            progress: '开始检测',
            progressIndex: 2,
        },
    };

    getStudyTaskNum() {
        let options = {
            params: {
                mark: 'current',
            }
        };
        this.axios.get('/api/studytasks/studytasks', options).then((data) => {
            this.fullscreenLoading = false;
            this.loadingText = '正在上传文件，请不要关闭程序';
            let datas = data.data;
            this.studyTaskNum = datas.data.length;
            this.isStudyTask = this.studyTaskNum < 8;
            if (!this.isStudyTask) {
                this.$alert('当前学习任务个数最多为8个，请提交已完成的学习任务状态再添加', '提示').catch(() => { });
                this.isEditable = false;
            }
        })
    }

    //检测学习任务名称
    checkName() {
        //校验名字
        if (!(/^[^\s]{2,20}$/.test(this.checkTaskName))) {
            this.isCheckName = true;
            return false;
        } else {
            this.isCheckName = false;
        }
        let options = {
            params: {
                checkTaskName: this.checkTaskName,
            }
        };
        this.checkTaskName != '' && this.axios.get('/api/studytasks/checkTaskName', options).then((data) => {
            if (data.data != 1) {
                this.checkTaskName = '';
                this.$alert('该学习任务名称已存在', '提示').catch(() => { });
                return false;
            }
        })
    }

    //上传文件的验证
    beforeUpload(file) {
        this.FileListLen++;
        this.fullscreenLoading = true;
    }

    initNum() {
        this.successLen = 0;
        this.FileListLen = 0;
        this.axios.get('/api/studytasks/checkdb/ishave').then((data) => { });
    }

    //成功上传文件
    handleSuccess(file) {
        if (typeof file == 'object') {
            this.fileList.push(file);
        } else {
            this.$message.error(file);
        }
        this.successLen++;
        this.successLen == this.FileListLen && (this.fullscreenLoading = false);
    }
    //成功上传文件
    handleError(file) {
        this.fullscreenLoading = false;
        this.successLen++;
        this.successLen == this.FileListLen && (this.fullscreenLoading = false);
    }

    allSelect() {
        if (this.isAllSelect) {
            this.delList = this.fileList;
        } else {
            this.delList = [];
        }
    }

    selectChange() {
        if (this.delList.length == this.fileList.length) {
            this.isAllSelect = true;
        } else {
            this.isAllSelect = false;
        }
    }

    //删除文件
    delFileList() {
        if (this.isAllSelect) {
            this.fileList = [];
        } else {
            this.delList.forEach(item => {
                let index = this.utilFun.findIndex(this.fileList, item);
                this.fileList.splice(index, 1);
            });
        }
        this.isAllSelect = false;
        this.delList = [];
        this.fileNum = this.fileList.length;
    }
    //下一步
    async next() {
        this.changeState('selfCheck', 'check');
        let isError = false;
        let checkNameIsRight = false;
        if (this.checkTaskName == '') {
            this.$alert('请填写学习任务名称', '提示').catch(() => { });
            return false;
        }
        if (this.fileList.length == 0) {
            this.$alert('请上传要检测的文件', '提示').catch(() => { });
            return false;
        }
        checkNameIsRight = await this.axios.get('/api/studytasks/checkTaskName', {
            params: {
                checkTaskName: this.checkTaskName,
            }
        }).then((data) => {
            if (data.data != 1) {
                return false;
            } else {
                return true;
            }
        })
        if (this.isCheckName || !checkNameIsRight) {
            return false;
        }
        if (this.fileList.length > 100) {
            this.$alert('仅能上传不超过100篇作业文献', '提示').catch(() => { });
            return false;
        }
        this.fileList.forEach(item => {
            if (item.status == 0) {
                isError = true;
            }
        })
        if (isError) {
            this.$confirm('请删除上传失败的文件再检测，如果不手动删除，系统将自动删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let cacheList = [];
                this.fileList.forEach((item) => {
                    if (item.status == 1) {
                        cacheList.push(item);
                    }
                });
                this.fileList = cacheList;
                if (this.fileList.length == 0) {
                    this.$alert('请上传要检测的文件', '提示').catch(() => { });
                    return false;
                }
                this.progressIndex = this.progressIndex + 1;
                this.progress = this.progressObj[this.progressIndex].progress;
                console.log(this.fileList);
            }).catch(() => {
                return false;
            });
            //this.$alert('请删除上传失败的文件再检测', '提示').catch(() => { });
            return false;
        }
        this.progressIndex = this.progressIndex + 1;
        this.progress = this.progressObj[this.progressIndex].progress;
    }
    //上一步
    previous() {
        // 时间追踪start
        _hmt.push(['_trackEvent', '课程作业_送检作业', '上一步', '事件价值', 1]);
        // end
        this.progressIndex = this.progressIndex - 1;
        this.progress = this.progressObj[this.progressIndex].progress;
    }

    //判断是否存在自建库
    //haveCheckdb() {
    //    this.axios.get('/api/studytasks/checkdb/ishave').then((data) => {
    //        this.isHaveCheckdb = data.data != '';
    //        this.isHaveCheckdb && (this.checkdbName = data.data);
    //    })
    //}

    //获取万方库列表
    getCheckDBList() {
        this.axios.get('/api/studytasks/getcheckwfdb').then((data) => {
            this.checkDBList = data.data;
            this.checkList = [];
            this.checkDBList.forEach(item => {
                this.checkList.push(item.checkDBId);
            })
        })
    }

    //关闭万方库弹窗回调
    checkDBListClose(done) {
        // (this.urlObj['chechDb'].state == 'selected') && this.changeState('chechDb');
        // this.checkList = [];
        done();
    }

    //关闭万方库弹窗回调
    checkDBListOpen() {
        this.checkDBListIsShow = true;
    }

    //确定万方库
    marksureCheckDB() {
        this.checkDBListIsShow = false;
        this.changeState('chechDb', 'noshow');
    }

    //改变状态
    changeState(obj, action?) {
        if (obj == 'selfCheck' && this.fileList.length <= 1) {
            if (action != 'check') {
                this.$alert('大于等于两篇才可以作业互查', '提示').catch(() => { });
            }
            this.urlObj[obj].state = 'normal';
            this.isEachOther = 0;
            return false;
        }
        if (action == 'check') {
            return false;
        }
        //if (obj =='chechDb'&&!this.isHaveCheckdb) {
        //    this.$alert('请创建自建库后再进行比对库检测', '提示').catch(() => { });
        //    return false;
        //}
        if (this.urlObj[obj].state == 'normal') {
            this.urlObj[obj].state = 'selected';
            if (obj == 'chechDb' && action !== 'noshow') {
                this.isCheckDb = 1;
                this.getCheckDBList();
                this.checkDBListIsShow = true;
            } else if (obj == 'chechDb') {
                this.isCheckDb = 1;
            } else if (obj == 'selfCheck') {
                this.isEachOther = 1;
            }
        } else {
            this.urlObj[obj].state = 'normal';
            if (obj == 'chechDb') {
                this.isCheckDb = 0;
            } else if (obj == 'selfCheck') {
                this.isEachOther = 0;
            }
        }
    }

    //解析url
    analysisUrl(obj) {
        if (this.urlObj[obj].state == 'normal') {
            return this.urlObj[obj].normal;
        } else {
            return this.urlObj[obj].selected;
        }
    }

    //定向检测
    directionalCheck() {
        //修改状态
        this.changeState('directional');
        if (this.urlObj.directional.state == 'selected') {
            //显示定向检测
            this.$store.commit({
                type: 'changeDirectionalCheckIsShow',
                directionalCheckIsShow: true,
            });
        }
    }
    //修改定向检测
    revise() {
        //显示定向检测
        this.$store.commit({
            type: 'changeDirectionalCheckIsShow',
            directionalCheckIsShow: true,
        });
    }
    //开始检测
    startCheck() {
        //验证
        let para = (<any>Object).assign({}, {
            checkTaskName: this.checkTaskName,
            homeWorkModel: this.fileList,
            isEachOther: this.isEachOther,
            isCheckDb: this.isCheckDb,
        });
        if (this.receiveData.type == 'batch') {
            para.singleMultipleModel = this.receiveData.fileList;
        } else if (this.receiveData.type == 'single') {
            para.oneSingleMultiple = this.receiveData.fileList;
        }
        let mark = true;
        if (para.isCheckDb != 0 || para.isEachOther != 0) {
            mark = false;
        }
        if (this.urlObj.directional.state === 'selected' && (para.singleMultipleModel && para.singleMultipleModel.length != 0) || (para.oneSingleMultiple && para.oneSingleMultiple.length != 0)) {
            mark = false;
        }
        if (mark) {
            this.$alert('请至少选择一种检测方式进行检测', '提示').catch(() => { });
            return false;
        }

        if (!(this.$refs.child as any).judgeStatus()) {
            this.$alert('文件列表中包含上传失败的送检文献，请从列表中删除这些文献后再进行送检。', '提示').catch(() => { });
            return false;
        }

        let listText = [];
        (<any>Object).keys(this.urlObj).forEach(item => {
            this.urlObj[item].state == 'selected' && listText.push(this.urlObj[item].name);
        })
        this.checkTypeText = listText.join(',');
        this.startCheckIsShow = true;
    }

    //确定检测
    makeSureCheck() {
        let checkCost
        if (this.checkTypeText.indexOf('学术库检测') == -1) {
            checkCost = this.fileList.length * this.checkTypeText.split(',').length * 10;
        } else {
            checkCost = this.fileList.length * 25 + this.fileList.length * (this.checkTypeText.split(',').length - 1) * 10;
        }
        if (this.restCount < checkCost) {
            this.$alert('您的账户余额不足，请联系管理员充值！', '提示').catch(() => { });
            return false;
        }
        let para = (<any>Object).assign({}, {
            checkTaskName: this.checkTaskName,
            homeWorkModel: this.fileList,
            isEachOther: this.isEachOther,
            isCheckDb: this.isCheckDb,
            checkWFDBIds: this.checkList.join(','),
            checkCost: checkCost
        });
        if (this.receiveData.type == 'batch') {
            para.singleMultipleModel = this.receiveData.fileList;
        } else if (this.receiveData.type == 'single') {
            para.oneSingleMultiple = this.receiveData.fileList;
        }

        this.loadingText = '请稍等';
        this.fullscreenLoading = true;
        // end
        this.axios.post('/api/studytasks/startcheck', para).then((data) => {
            let datas = data.data;
            this.fullscreenLoading = false;
                if (datas === 'TransFailed') {
                    this.$alert('交易错误，请稍后重试！', '提示').catch(() => {
                        //更新路由状态信息
                        this.$store.commit({
                            type: 'changeMenuIndex',
                            currentMenuIndex: 'studytasks',
                        });
                        this.$router.push({
                            path: '/studytasks',
                        });
                    });
                    return false;
                } else if (datas === 'OutOfMoney') {
                    this.$alert('您的账户余额不足，请联系管理员充值！', '提示').catch(() => {
                        //更新路由状态信息
                        this.$store.commit({
                            type: 'changeMenuIndex',
                            currentMenuIndex: 'studytasks',
                        });
                        this.$router.push({
                            path: '/studytasks',
                        });
                    });
                    return false;
                }
                //更新路由状态信息
                this.$store.commit({
                    type: 'changeMenuIndex',
                    currentMenuIndex: 'studytasks',
                });
                this.$router.push({
                    path: '/studytasks',
                });
        });
    }
    //取消
    cancel() {
        this.startCheckIsShow = false;
    }
    //监听子组件
    checkSuccess(data) {
        this.receiveData = data;
        let mark = false;
        if (data.type == 'batch' && data.fileList.length != 0) {
            this.fileNameList = [];
            data.fileList.forEach(item => {
                this.fileNameList.push(item);
            })
        }
        if (data.type == '') {//没有设置
            mark = true;
        } else if (data.type == 'batch' && data.fileList.length == 0) {//批量
            mark = true;
        } else if (data.type == 'single') {//单篇
            let markSet = true;
            data.fileList.forEach(item => {
                if (item.Value.length != 0) {
                    markSet = false;
                }
            })
            if (markSet) {
                mark = true;
            }
        }
        if (mark) {
            //修改状态
            this.changeState('directional');
        }
    }
    uploaderError(error: any, file: any, type: any) {
        let nameList = file.name.split('.')
        nameList.pop()
        let name = nameList.join('.')
        let fileType = type == 'file' ? 'doc、docx、pdf' : 'rar、zip';
        let fileSize = type == 'file' ? '10' : '1000';
        if (error == 'Q_EXCEED_NUM_LIMIT') {
            this.$message({
                message: '被比对文献总数已达上限10篇，如再上传需先删除已上传文献',
                type: 'error'
            })
        } else if (error == 'Q_TYPE_DENIED') {
            this.$message({
                message: `《${name}》文件格式不正确，仅限${fileType}`,
                type: 'error'
            })
        } else if (error == 'F_EXCEED_SIZE') {
            this.$message({
                message: `《${name}》文件大小超过上限${fileSize}M，请重新上传`,
                type: 'error'
            })
        }
    }
    initUploaderZip() {
        var webUploaderOpt = {
            auto: true, // 是否自动上传
            //fileSingleSizeLimit: 1000 * 1024 * 1024,
            //fileSingleSizeLimitStr: '1000MB',
            multiple: false,
            threads: 1,
            // swf文件路径
            swf: '/static/Uploader.swf?_t=' + new Date().getTime(),
            // 文件接收服务端。
            server: 'api/studytasks/homeworks/uploadrar',
            // 选择文件的按钮。可选。
            // 内部根据当前运行是创建，可能是input元素，也可能是flash.
            pick: '#rar_upload',
            // 不压缩image, 默认如果是jpeg，文件上传前会压缩一把再上传！
            resize: false,
            formData: {
                // dbid: $("#dbid").val()
            },
            duplicate: true,
            accept: {
                title: '请选择rar或zip文件',
                extensions: 'rar,zip',
                mimeTypes: '.rar,.zip'
            }
        };
        let WebUploader: any = (<any>window).WebUploader;
        var uploader = WebUploader.create(webUploaderOpt);
        uploader.on('beforeFileQueued', (file) => {
            //if (file.size == 0) {
            //    this.$alert('上传文档大小不能为0，请重新上传!', '提示').catch(() => { });
            //    return false;
            //}
            this.fullscreenLoading = true;
        });
        uploader.on('fileQueued', (file) => {
        });
        // 文件上传过程中创建进度条实时显示。
        uploader.on('uploadProgress', (file, percentage) => {
        });
        uploader.on('uploadSuccess', (file, response) => {
            response.forEach((item) => {
                this.handleSuccess(item);
            })
        });
        uploader.on('uploadError', (error, reason) => {
            this.$alert('上传失败', '提示').catch(() => { });
        });
        uploader.on('error', (error: any, file: any) => {
            this.uploaderError(error, file, 'zip');
        });
        uploader.on("uploadFinished", () => {
            this.fullscreenLoading = false;
            uploader.reset();
            // 时间追踪start
            _hmt.push(['_trackEvent', '课程作业_送检作业', '上传压缩包', '事件价值', 1]);
            // end
        });
    }
    initUploaderFile() {
        let webUploaderOpt = {
            auto: true, // 是否自动上传
            //fileSingleSizeLimit: 10 * 1024 * 1024,
            //fileSingleSizeLimitStr: '10M',
            fileNumLimit: 100,
            //fileNumLimit: 1,
            multiple: true,
            threads: 1,
            // swf文件路径
            swf: '/static/Uploader.swf?_t=' + new Date().getTime(),
            // 文件接收服务端。
            server: 'api/studytasks/homeworks/upload',
            // 选择文件的按钮。可选。
            // 内部根据当前运行是创建，可能是input元素，也可能是flash.
            pick: '#file_upload',
            // 不压缩image, 默认如果是jpeg，文件上传前会压缩一把再上传！
            resize: false,
            formData: {
                // dbid: $("#dbid").val()
            },
            duplicate: true,
            accept: {
                title: 'Documents',
                extensions: 'doc,docx,txt,pdf,rtf',
                mimeTypes: '.doc,.docx,.txt,.pdf,.rtf'
            }
        };
        let WebUploader: any = (<any>window).WebUploader;
        let uploader = WebUploader.create(webUploaderOpt);
        uploader.on('beforeFileQueued', (file) => {
            //if (file.size == 0) {
            //    this.$alert('上传文档大小不能为0，请重新上传!', '提示').catch(() => { });
            //    return false;
            //}
            this.fullscreenLoading = true;
        });
        uploader.on('fileQueued', (file) => {
        });
        uploader.on('startUpload', (file: any, response: any) => {
            if (this.fileNum + uploader.getFiles().length > 100) {
                this.$message({
                    message: `本次可上传文献数量为${100 - this.fileNum}篇，请重新选择或删除部分已上传文献`,
                    type: 'error'
                });
                // this.uploadFileList = this.uploadFileList.slice(0, this.fileNum);
                uploader.reset();
            } else {
                this.fileNum = this.fileNum + uploader.getFiles().length;
            }
        });
        uploader.on('uploadSuccess', (file, response) => {
            this.handleSuccess(response);
        });
        uploader.on('uploadError', (error, reason) => {
            this.$alert('上传失败', '提示').catch(() => { });
        });
        uploader.on('error', (error: any, file: any) => {
            if (error == 'Q_EXCEED_NUM_LIMIT') {
                this.$message({
                    message: '上传不能超过100篇作业文献',
                    type: 'error'
                })
                return false;
            }
            this.uploaderError(error, file, 'file');
        });
        uploader.on("uploadFinished", (file) => {
            this.fullscreenLoading = false;
            uploader.reset();
            this.fileNum = this.fileList.length;
        });
    }
    getRestCount() {
        this.axios.get('/api/studytasks/getcheckcount').then((data) => {
            this.restCount = data.data;
        })
    }
    mounted() {
        this.fileList = [];
        // this.haveCheckdb();
        this.getStudyTaskNum();
        this.initUploaderZip();
        this.initUploaderFile();
        this.getRestCount();
    }
}
